export default {
  construpUserId: 0,
  cities: [],
  ibgeCities: [],
  segments: [],
  typeProfessions: [],
};
